/**
 * Modes Style01 - Button style: mode selection
 */
import { useState, useEffect } from 'react'
import type { TraitControlProps } from './types'

const DEFAULT_MODES = ['mode1', 'mode2', 'mode3']

export function ModesStyle01({
  state,
  onCommand,
  disabled = false,
}: TraitControlProps) {
  const current = (state?.currentMode ?? state?.mode ?? 'mode1') as string
  const [value, setValue] = useState(current)

  useEffect(() => {
    setValue((state?.currentMode ?? state?.mode ?? 'mode1') as string)
  }, [state?.currentMode, state?.mode])

  const handleSelect = (mode: string) => {
    setValue(mode)
    void onCommand('setMode', { mode })
  }

  return (
    <div className="smart-home-automation-field">
      <label>Modes</label>
      <div className="smart-home-automation-command-row">
        {DEFAULT_MODES.map((mode) => (
          <button
            key={mode}
            type="button"
            className={`smart-home-automation-command-btn glass ${value === mode ? 'active' : ''}`}
            onClick={() => handleSelect(mode)}
            disabled={disabled}
          >
            {mode}
          </button>
        ))}
      </div>
    </div>
  )
}
